module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJ1BMVEUAAADMQ0PMQ0PMQ0PMQ0PMQ0PMQ0PMQ0PMQ0PMQ0PMQ0PMQ0PMQ0MHCI3RAAAADHRSTlMACcUuluOauqWP0d4EwCCcAAAAb0lEQVQI12NgYDCJOerMAARiZ4AgkYGBUQfEOCTAwHIGDBwYbM6sOnOm9MxhhjlnGnVOSJ05yRBz5phQY82ZowwgLeJAAsRoFAISQKkT4ok6QKk5ZwprjgEVA7UrnTnTDdQOMxBuBdxSsDNOA50BABDbQ8llsYEJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_error.png
// module id = fICz
// module chunks = 15